import { Box, Container, Flex, Grid } from 'components/box';
import { Heading, Link as Href, Text } from 'components/typography';
import { Link } from 'components/configurable-routing';
import { css } from '@emotion/react';
import config from '../util/load-config';
import resourceUrl from '../util/make-url';

const AboutODOPage = () => (
  <Container>
    <Grid
      gridRowGap={[3, 4]}
      gridColumnGap={[3, 5]}
      gridTemplateColumns={['1fr', null, '1fr 1fr']}
    >
      <Box>
        <Grid>
          <Heading
            textAlign={['center', 'left']}
            fontSize={['title4', 'title3']}
            my={['1.5em', '1em']}
          >
            What&apos;s OneDayOnly?
          </Heading>

          <Text lineHeight="1.6">
            We&apos;re your new best friend! We get hold of a product, slash its
            price and then offer it to you for OneDayOnly. You&apos;ve got 24
            hours to take advantage of our generosity and then the deal is gone
            forever. Sad, but true.
          </Text>

          <Text lineHeight="1.6">
            Not only are we generous but we&apos;re also slightly psychic and
            know that you&apos;re about to ask what products we sell. We offer
            products from a range of electronics, gadgets, cosmetics and sport
            and lifestyle items at the lowest price you will find in South
            Africa. And no, we don&apos;t care if you bought something similar
            at the traffic lights for a lower price. That doesn&apos;t count and
            you know it.
          </Text>

          <Text lineHeight="1.6">
            Is it an impulse buy site? Certainly not. You&apos;ve got 24 hours
            to think it over and since you make less rational decisions in five
            seconds, we&apos;re giving you plenty of time. Careful though, if
            you want the product badly, chances are so does the rest of the
            nation so make it snappy and shove that beauty into your trolley
            pronto.
          </Text>

          <Text lineHeight="1.6">
            How do we do it you ask? We have busy little buyers who are working
            daily with international brands to bring you the lowest possible
            offer price. Isn&apos;t that sweet? We think so.
          </Text>
        </Grid>
      </Box>

      <Flex alignItems="flex-end">
        <img
          alt="Our team"
          css={css`
            max-width: 100%;
          `}
          src={resourceUrl('odo/team.png', {
            width: 800,
            isAssetUrl: true,
          })}
        />
      </Flex>

      <Box
        mt={[3, 4]}
        css={theme => css`
          border-bottom: 1px solid ${theme.colors.mediumGrey};
          grid-column: 1 / -1;
        `}
      />

      <Grid>
        <Heading
          textAlign={['center', 'left']}
          fontSize={['title4', 'title3']}
          my={['1.5em', '1em']}
        >
          How does this work?
        </Heading>

        <Text lineHeight="1.6">
          Simple: We offer a few great ways to stay up to date.
        </Text>

        <Text lineHeight="1.6">
          First and foremost there&apos;s our{' '}
          <Link
            href="https://link.onedayonly.co.za/join/6kh/signup"
            target="_blank"
          >
            email newsletter
          </Link>
          . It&apos;s the full experience with one difference: you don&apos;t
          have to visit our website. Sign up and forget about it. Until tomorrow
          morning when you&apos;ll get our first email. You&apos;ll find the
          subscription form at the left of most pages.
        </Text>

        <Text lineHeight="1.6">
          Don&apos;t want to receive our daily email? Fine. Surely (don&apos;t
          call me Shirley) you&apos;re on{' '}
          <Href href={config.social.facebookPageUrl}>Facebook</Href>? Well,
          become a fan and stay up to date!
        </Text>

        <Text lineHeight="1.6">
          Follow us on <Href href={config.social.twitterPageUrl}>Twitter!</Href>{' '}
          You&apos;ll get daily updates and be amongst the first to hear about
          our insane deals. Oh! Don&apos;t forget to spread the word!
        </Text>
      </Grid>

      <Grid>
        <Heading
          textAlign={['center', 'left']}
          fontSize={['title4', 'title3']}
          my={['1.5em', '1em']}
        >
          Any questions?
        </Heading>

        <Text lineHeight="1.6">
          At OneDayOnly we do our best to provide as much information about
          ourselves and our daily sales right here on the site. Before
          contacting us please first check our{' '}
          <Link href="faq">
            <Href>FAQ section</Href>
          </Link>
          .
        </Text>

        <Text lineHeight="1.6">
          If you have a question that isn&apos;t covered here, or is specific to
          an order, then we have a couple of different ways for you to get hold
          of us.
        </Text>

        <Text lineHeight="1.6">
          These options are devastatingly similar, because you can 1) fill out
          the form that pops up when you click &quot;Contact Us&quot; or you can
          2) shoot through an email to{' '}
          <a href="mailto:customerservice@onedayonly.co.za">
            customerservice@onedayonly.co.za
          </a>
          .
        </Text>

        <Text lineHeight="1.6">
          Luckily, we&apos;re surprisingly quick in getting a meaningful
          response back to you.
        </Text>
      </Grid>
    </Grid>
  </Container>
);

export default AboutODOPage;
